import LayoutTemplate from 'common/templates/Layout/LayoutTemplate';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { authActions } from 'state/auth/auth.actions';
import { AppState } from 'state/reducer';

const mapStateToProps = (state: AppState) => ({
  currentRoute: state.router.location.pathname,
  loading: state.auth.loading,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      logout: authActions.logout,
    },
    dispatch
  );

export const DashboardContainerLayout = connect(
  mapStateToProps,
  mapDispatchToProps
)(LayoutTemplate);

// eslint-disable-next-line import/no-default-export
// export default LayoutPage;
